export default {
  setItens(state, payload) {
    state.itens = payload;
  },
  setItem(state, payload) {
    state.itens.push(payload);
  },
  setSheet(state, payload) {
    state.sheet = payload;
  }
};
